export enum PaymentStatusEnum {
  PENDING = 'pending',
  APPROVED = 'approved',
  REFUNDED = 'refunded',
  CANCELLED = 'cancelled',
  DEALER = 'dealer',
  ERROR = 'error',
  AUTHORIZED = 'authorized',
  IN_PROCESS = 'in_process',
  IN_MEDIATION = 'in_mediation',
  REJECTED = 'rejected',
  CHARGED_BACK = 'charged_back',
}
